import {
  FacilityRequest,
  FacilityResponse,
  FacilityUpdate,
  HealthcareFacilityStats,
} from "../types/facility.definition";
import { Manager } from "../types/manager.definition";
import {
  Order,
  SearchRequest,
  SearchResponse,
} from "../types/search.definition";
import {
  createHealthcareFacility,
  disableHealthcareFacility,
  getFacilityStaffStats,
  getHealthcareFacilityById,
  getHealthcareFacilityManagers,
  getHealthcareFacilityStatistics,
  requestSearchHealthFacilities,
  restoreHealthcareFacility,
  updateHealthcareFacility,
} from "../webclients/facility.client";

export const facilitiesApi = {
  // MED-1758: active staff of a facility, which a new licence must cover.
  fetchActiveStaffCounts: async (
    id: number
  ): Promise<{ doctors: number; secretaries: number }> => {
    const response = await getFacilityStaffStats(id);
    const metrics = response.data?.summary?.metrics;
    return {
      doctors: metrics?.doctors?.active ?? 0,
      secretaries: metrics?.secretaries?.active ?? 0,
    };
  },
  fetchFacilityStats: async (id: number): Promise<HealthcareFacilityStats> => {
    const response = await getHealthcareFacilityStatistics(id);
    return response.data;
  },
  updateFacility: async (
    id: number,
    data: FacilityUpdate
  ): Promise<FacilityResponse> => {
    const response = await updateHealthcareFacility(data, id);
    return response.data;
  },
  createFacility: async (data: FacilityRequest): Promise<FacilityResponse> => {
    const response = await createHealthcareFacility(data);
    return response.data;
  },

  searchFacilities: async (keyword: string): Promise<FacilityResponse[]> => {
    const searchRequest: SearchRequest = {
      paginationSettings: { limit: 20, offset: 0 },
      sortBy: { property: "name", order: Order.ASC },
      query: { keyword },
    };
    const response = await requestSearchHealthFacilities(searchRequest);
    const result = response.data as SearchResponse<FacilityResponse>;
    return result.data;
  },

  getFacilityById: async (id: number): Promise<FacilityResponse> => {
    const response = await getHealthcareFacilityById(id);
    return response.data;
  },

  // MED-1443: disable/re-enable a facility. Both are real server round-trips —
  // the page used to flip the badge in Redux only, so a reload undid it.
  disableFacility: async (id: number): Promise<void> => {
    await disableHealthcareFacility(id);
  },

  restoreFacility: async (id: number): Promise<void> => {
    await restoreHealthcareFacility(id);
  },

  getFacilityManagers: async (facilityId: number): Promise<Manager[]> => {
    const response = await getHealthcareFacilityManagers(facilityId);
    return response.data;
  },
};
